import * as React from 'react';
import { DataGroup } from '../../../../components/data-group/DataGroup';
import { DataGroupPoint } from '../../../../components/data-group/DataGroupPoint';
import { TimeZoneAbbreviations } from '../../../../components/utility/timezones';
import { toLongDateTimeNoSeconds } from '../../../../utils/date-utils';
import { EndShipmentAction } from '../../../models/shipments/shipment-action';

interface IProps {
    endStop: EndShipmentAction;
}

export const ActionContentRouteEnd = (props : IProps) => {

    return <div>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="stop-panel-title">Destination</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">

                        <DataGroup title="">

                            {
                                props.endStop.address
                                    ? <DataGroupPoint
                                        label="Address"
                                        value={ `${ props.endStop.address.addressLine1 }
                                            ${props.endStop.address.city}, 
                                            ${props.endStop.address.stateProvince} 
                                            ${props.endStop.address.postalCode}`} 
                                    />
                                    : null
                            }
                            <DataGroupPoint
                                label="Shipment Time"
                                value={ 
                                    props.endStop.actionTime
                                    ? `${ toLongDateTimeNoSeconds(props.endStop.actionTime.local) } ${ TimeZoneAbbreviations[props.endStop.actionTime.timeZone] }` 
                                        : ''
                                } 
                            />
                            <DataGroupPoint
                                label="Mileage"
                                value={ props.endStop.distance } />
                            <DataGroupPoint
                                label="Travel Time"
                                value={ props.endStop.travelTime } />                            
                            <DataGroupPoint
                                label="Name"
                                value={props.endStop.name} />
                        </DataGroup>

                    </div>
                </div>
            </div>;
};
